/* @flow */

import { type NETGEM_API_PLAYINGHISTORY, type PLAYING_HISTORY_ARRAY_TYPE, playingHistoryObjectToArray } from '../../libs/netgemLibrary/v8/types/PlayingHistory';
import { LoadableStatus } from '../loadable/loadable';
import { getHashAndTimestampLookUpFromDates } from './helpers';

class PlayingHistoryCache {
  static items: PLAYING_HISTORY_ARRAY_TYPE = [];

  static hashCode: number | null = null;

  // $FlowFixMe[unsupported-syntax] Flow does not support symbols yet
  get [Symbol.toStringTag]() {
    return 'PlayingHistoryCache';
  }

  static checkGet: (newPlayingHistory: NETGEM_API_PLAYINGHISTORY, status: LoadableStatus, ordered?: boolean) => PLAYING_HISTORY_ARRAY_TYPE = (newPlayingHistory, status, ordered = false) => {
    if (status !== LoadableStatus.Loaded) {
      // Not loaded yet
      return [];
    }

    const items = playingHistoryObjectToArray(newPlayingHistory);

    const hashAndTimestampLookUp = getHashAndTimestampLookUpFromDates(items);

    if (hashAndTimestampLookUp === null) {
      return [];
    }

    const { hash: newHashCode, timestampLookUp } = hashAndTimestampLookUp;

    if (newHashCode !== PlayingHistoryCache.hashCode) {
      // Cache items
      PlayingHistoryCache.items = items;
      PlayingHistoryCache.hashCode = newHashCode;

      if (ordered) {
        PlayingHistoryCache.items.sort((a, b) => timestampLookUp[b.programId] - timestampLookUp[a.programId]);
      }
    }

    return PlayingHistoryCache.items;
  };
}

export default PlayingHistoryCache;
